<template>
  <DashboardWidgetLineSmooth class="widget-cassa-disavanzo" title="Cassa e Disavanzo" :dataY="dataY" :dataX="dataX" legend="Cassa e Disavanzo" />
</template>

<script>

export default {
  name: 'dashboard-widget-cassa-disavanzo',
  components: {
    DashboardWidgetLineSmooth: () => import('../BaseWidgets/DashboardWidgetLineSmooth'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dataY () {
      return this.values.map(v => {
        return v.value;
      });
    },
    dataX () {
      return this.values.map(v => {
        return v.date;
      });
    },
  },
};

</script>
